import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// Register the brand's custom font-size utilities (tokens.css / application.css)
// so tailwind-merge classifies them as font-size, not text-color. Without this,
// `cn("text-nano", "text-dusk-80")` drops the size as a false text-* conflict.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["nano", "micro", "meta", "link", "body-sm", "body"] },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
